"use client";
import { useTranslation } from "@/i18n/client";
import s from "./TimeUnit.module.scss";

export interface TimeUnitProps {
  value: string | number;
  type: string;
}

export default function TimeUnit(props: TimeUnitProps) {
  const { value, type } = props;
  const { t } = useTranslation();

  return (
    <>
      <div className={s.time}>{value}</div>
      <div className={s.timeLabel}>
        {t(`countdown-timer.time.${type.toUpperCase()}.label`)}
      </div>
    </>
  );
}
